import { gql } from '@apollo/client';
import { tilesetDataFragment } from 'api/fragments/workflows';

export const createTilesetMutation = gql`
  mutation addJourneyFragment(
    $name: String!
    $description: String
    $fragment: WorkflowFragmentDataInput!
  ) {
    addWorkflowFragment(name: $name, description: $description, data: $fragment) {
      id
    }
  }
`;

export const getTilesetsQuery = gql`
  query journeyTilesets {
    workflowFragments(pagination: { offset: 0, limit: 1000 }) {
      results {
        id
        name
        description
        importCount
        createdAt
        createdBy
        data {
          ...TilesetDataFragment
        }
      }
    }
  }
  ${tilesetDataFragment}
`;

export const deleteTilesetMutation = gql`
  mutation deleteJourneyTileset($id: String!) {
    deleteWorkflowFragment(id: $id)
  }
`;

export const incrementTilesetMutation = gql`
  mutation incrementTileset($id: String!) {
    incrementImportCount(id: $id)
  }
`;
